import { render } from "./topPickSkeleton.vue?vue&type=template&id=75faa9f4&scoped=true"
import script from "./topPickSkeleton.vue?vue&type=script&lang=js"
export * from "./topPickSkeleton.vue?vue&type=script&lang=js"

import "./topPickSkeleton.vue?vue&type=style&index=0&id=75faa9f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75faa9f4"]])

export default __exports__